import { Injectable } from '@angular/core';

import { DocPart } from '../../models/doc-part';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class DocPartService extends BackendBaseService {
  /**
   * Base relative URL from base URL for doc parts resource
   *
   * @var  {string}
   */
  url: string = 'doc_parts';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * Save doc part
   * @param  {DocPart}      docPart Doc part to save
   * @return {Promise<any>}         Server response
   */
  save(docPart: DocPart): Promise<any> {
    return super.save({
      id: docPart.id,
      doc_part: docPart
    });
  }

  /**
   * Run the static Radius-tag validator on the given contents.
   * Returns { valid: boolean, errors: [{line, severity, tag, message, snippet}] }.
   */
  validateTags(contents: string): Promise<any> {
    return this.httpClient.post(`${this.url}/validate_tags.json`, { contents: contents });
  }
}
